
<div :style="{width: width}" class="c-suggestion__container" v-show=isActive @mousedown=selectSuggestion>
<div class="c-suggestion__suggest-row" v-for="(suggestion, index) in suggestions" :key=index v-bind:class="{'-active': index==currentFocus}"
  v-html="previous_words + ' ' + suggestion.replace(current_word, '<b>'+current_word+'</b>')"></div>
</div>
